<span class="page-heading font-size-10 font-size-6-md mb-0 mt-1" [ngClass]="theme">{{ heading }}</span>
